import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: colors.common.white,
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#000000'
    },
    secondary: {
      main: colors.indigo[500]
    },
    text: {
      primary: colors.grey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows,
  typography: {
    fontFamily: [
      'Roboto',
    ].join(','),
  },
});

export default theme;
